'use strict';

var log = require('../../log/Log').channel('AudioControlsExtension');

var AudioControlsExtension = function($scope, $ionicPopover, $timeout, 
                                      $window, $ionicPosition,
                                      IosTouchEventService) {
    log.info('initializing');

    var vm = this;
    var audioControls = null;
    var audioControlsCall = null;
    var saveVolume = null;
    var volumeReleasePromise;
    var incrementVolume = 0;
    var receiveGainUnwatch = null;
    var wrappedVolumeHandlers = IosTouchEventService.wrapHandlers(
        incrementVolumeTouch, incrementVolumeRelease);

    vm.audiocontrols = {};
    vm.audiocontrols.isVolumeHeld = false;
    vm.audiocontrols.isUserChangingVolume = false;
    vm.audiocontrols.showAudioControls = showAudioControls;
    vm.audiocontrols.hideAudioControls = hideAudioControls;
    vm.audiocontrols.incrementVolumeTouch = wrappedVolumeHandlers.onTouch;
    vm.audiocontrols.incrementVolumeRelease = wrappedVolumeHandlers.onRelease;
    vm.audiocontrols.volume = 0;
    vm.audiocontrols.areAudioControlsVisible = areAudioControlsVisible;
    vm.audiocontrols.sliderOptions = {
        floor: -10,
        ceil: 10,
        vertical: true,
        hidePointerLabels: true,
        hideLimitLabels: true,
        showSelectionBar: true,
        disableAnimation: true,
        onStart: onVolumeHold,
        onChange: onVolumeChanged,
        onEnd: onVolumeRelease,
        interval: 10
    };
    vm.audiocontrols.sliderHidden = true;

    $scope.$on('popover.hidden', function($event, popover) {
        if (popover === audioControls) {
            popover.remove();
        }
    });

    $scope.$on('popover.removed', function($event, popover) {
        if (popover === audioControls) {
            if (receiveGainUnwatch) {
                receiveGainUnwatch();
                receiveGainUnwatch = null;
            }
            audioControlsCall = null;
            audioControls = null;
            vm.audiocontrols.sliderHidden = true;
        }
    });

    function areAudioControlsVisible(call) { 
        return audioControlsCall === call;
    }

    function hideAudioControls() {
        if (audioControls !== null) {
            return audioControls.remove();
        }
        return null;
    }

    function showAudioControls(call, $event) {
        var hiding = hideAudioControls();
        if (!hiding) {
            show();
        }
        else {
            hiding.then(show);
        }

        function show() {
            $ionicPopover.fromTemplateUrl('callAudioControl.html', {
                scope: $scope,
                // HACK/undocumented: positionView overrides an internal 
                // positioning function, due to being combined via an internal 
                // .extend()
                positionView: positionAudioControlsView
            }).then(function(popover) {
                audioControls = popover;
                audioControlsCall = call;
                receiveGainUnwatch = 
                    $scope.$watch(function() { 
                                    return audioControlsCall ? 
                                        audioControlsCall.receiveGain : 0; 
                                  }, 
                                  onCallReceiveGainChanged);                        
                audioControls.show($event).then(function() {
                    vm.audiocontrols.sliderHidden = false;
                });
            });
        }
    }

    function positionAudioControlsView(target, popoverEle) {
        // Adapted from $ionicPopover source
        var POPOVER_BODY_PADDING = 6;
        var targetEle = angular.element(target.target || target);
        var buttonOffset = $ionicPosition.offset(targetEle);
        var popoverWidth = popoverEle.prop('offsetWidth');
        var popoverHeight = popoverEle.prop('offsetHeight');
        // Use innerWidth and innerHeight, because clientWidth and clientHeight
        // doesn't work consistently for body on all platforms
        var bodyWidth = $window.innerWidth;
        var bodyHeight = $window.innerHeight;

        var popoverCSS = {
            left: buttonOffset.left + buttonOffset.width / 2 - popoverWidth / 2
        };
        var arrowEle = angular.element(popoverEle[0].querySelector('.arrow-left'));

        if (popoverCSS.left < POPOVER_BODY_PADDING) {
            popoverCSS.left = POPOVER_BODY_PADDING;
        } else if (popoverCSS.left + popoverWidth + POPOVER_BODY_PADDING > bodyWidth) {
            popoverCSS.left = bodyWidth - popoverWidth - POPOVER_BODY_PADDING;
        }

        // If the popover when popped down stretches past bottom of screen,
        // adjust it to fit.
        if (buttonOffset.top + popoverHeight > bodyHeight &&
            buttonOffset.top - popoverHeight > 0) {
            popoverCSS.top = bodyHeight - popoverHeight;
        } else {
            popoverCSS.top = buttonOffset.top;
        }

        arrowEle.css({
            top: buttonOffset.top + buttonOffset.height / 2 -
                 arrowEle.prop('offsetHeight') / 2 - popoverCSS.top + 'px'
        });

        popoverEle.css({
            top: popoverCSS.top + 'px',
            left: popoverCSS.left + 'px',
            marginLeft: '0',
            opacity: '1'
        });
    }

    function onCallReceiveGainChanged(newValue, oldValue) {
        if (vm.audiocontrols.isUserChangingVolume) {
            saveVolume = newValue;
            scheduleVolumeRelease();
        } else {
            vm.audiocontrols.volume = newValue;
       }
    }

    function incrementVolumeTouch($event, increment) {
        if (!angular.isDefined(increment)) {
            increment = 1;
        }
        if (!vm.audiocontrols.isIncrementVolumeHeld) {
            incrementVolume = vm.audiocontrols.volume;
        }
        incrementVolume = Math.max(vm.audiocontrols.sliderOptions.floor, 
                             Math.min(vm.audiocontrols.sliderOptions.ceil, 
                                      incrementVolume + increment));
        vm.audiocontrols.isIncrementVolumeHeld = true;
        vm.audiocontrols.isUserChangingVolume = true;
        saveVolume = null;
        vm.audiocontrols.volume = incrementVolume;
        setVolume(incrementVolume);
    }

    function incrementVolumeRelease($event) {
        vm.audiocontrols.isIncrementVolumeHeld = false;
        scheduleVolumeRelease();
    }

    function setVolume(newValue) {
        if (audioControlsCall !== null) {
            audioControlsCall.$setReceiveGain(newValue);
        }
    }

    function onVolumeChanged(sliderId, value) {
        if (vm.audiocontrols.isVolumeHeld) {
            setVolume(value);
        }
    }

    function onVolumeHold() {
        vm.audiocontrols.isVolumeHeld = true;
        vm.audiocontrols.isUserChangingVolume = true;
        saveVolume = null;
    }

    function releaseVolume() {
        if (!vm.audiocontrols.isVolumeHeld) {
            vm.audiocontrols.isUserChangingVolume = false;
            if (saveVolume !== null) {
                vm.audiocontrols.volume = saveVolume;
            }
        }
    }

    function scheduleVolumeRelease() {
        $timeout.cancel(volumeReleasePromise);
        volumeReleasePromise = $timeout(releaseVolume, 300);
    }

    function onVolumeRelease() {
        vm.audiocontrols.isVolumeHeld = false;
        scheduleVolumeRelease();
    }
};

module.exports = AudioControlsExtension;
